export class SubTaskInput {
    public ticketId: number = 0;
    public title: string = '';
}
